import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// The "Finish your Review" modal.
//
// Lives on the builder ROOT rather than on the modal element itself so the left
// menu's "Submit Review" button — which sits inside the menu turbo-frame, a
// different subtree — can reach it without a Stimulus outlet (this repo has none).
export default class extends Controller {
  static targets = ["modal", "note", "noteField", "submit"]

  open() {
    if (!this.hasModalTarget) return

    Modal.getOrCreateInstance(this.modalTarget).show()
  }

  toggleNote(event) {
    if (!this.hasNoteTarget) return

    const revealed = this.noteTarget.hidden
    this.noteTarget.hidden = !revealed
    event.currentTarget.setAttribute("aria-expanded", revealed ? "true" : "false")

    if (revealed) this.noteFieldTarget?.focus()
  }
}
